import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const { cartId } = state.pages.checkoutShipping;
    const cartState = cartId ? getCartState(state, cartId) : getCurrentCartState(state);
    const { isUpdatingCart } = state.pages.checkoutShipping;

    return {
        cart: cartState.value,
        isLoading: !cartState.value || cartState.isLoading || isUpdatingCart,
    };
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface CheckoutContinueButtonStyles {
    container?: GridContainerProps;
    buttonsGridItem?: GridItemProps;
    continueButton?: ButtonPresentationProps;
}

export const cartTotalStyles: CheckoutContinueButtonStyles = {
    container: { gap: 10 },
    buttonsGridItem: {
        width: 12,
        css: css`
            > div {
                width: 100%;
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display block;
                        `,
                        css`
                            display block;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            display none;
                        `,
                        css`
                            display none;
                        `,
                    ],
                    "min",
                )
            }

        `,
    },
    continueButton: {
        variant: "primary",
        css: css`
            width: 100%;
            margin: 1rem 0;
        `,
    },
};

const styles = cartTotalStyles;
const CheckoutContinueButton: FC<Props> = ({
    isLoading,
}) => {
    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.buttonsGridItem}>
                <Button
                    {...styles.continueButton}
                    type="submit"
                    disabled={isLoading}
                    data-test-selector="checkoutShippingContinueButton"
                >
                    {translate("Continue")}
                </Button>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(CheckoutContinueButton),
    definition: {
        group: "Checkout - Shipping",
        allowedContexts: ["CheckoutShippingPage"],
        displayName: "Checkout Continue Button",
    },
};

export default widgetModule;